import { CVAC_LOAD_MORE_HOTELS } from "./customerChatMessageDisplay";

/**
 * Strip invalid load_more_hotels so UI does not offer pagination when there is nothing to load.
 * @param {unknown[]} cards
 * @param {unknown} loadMore
 * @returns {object|null}
 */
export function sanitizeAssistantLoadMoreHotels(cards, loadMore) {
  const c = Array.isArray(cards) ? cards : [];
  if (!loadMore || typeof loadMore !== "object") return null;
  if (c.length === 0) return null;
  if (loadMore.visible === false) return null;
  if (loadMore.has_more !== true) return null;
  const pc = Number(loadMore.presented_count);
  if (Number.isFinite(pc) && pc <= 0) return null;
  return loadMore;
}

/**
 * Adds "הצג עוד 5" as a bubble quick-reply (no sticky bottom bar).
 * @param {unknown[]} quickReplies
 * @param {object|null} loadMoreSanitized — output of sanitizeAssistantLoadMoreHotels
 * @returns {Array<{label?: string, value?: string}>}
 */
function isOfferPickQuickReply(q) {
  const val = String(q?.value ?? "").trim();
  return /^אני בוחר באפשרות \d+$/.test(val);
}

/**
 * Order: כפתורי «בחרו/אפשרות», אחריהם «הצג עוד 5», ואז פעולות המשך (סינון וכו').
 */
export function mergeLoadMoreIntoQuickReplies(quickReplies, loadMoreSanitized) {
  const qrs = Array.isArray(quickReplies) ? [...quickReplies] : [];
  if (!loadMoreSanitized || typeof loadMoreSanitized !== "object") return qrs;
  if (loadMoreSanitized.visible !== true || loadMoreSanitized.has_more !== true) return qrs;
  const v = CVAC_LOAD_MORE_HOTELS;
  if (qrs.some((q) => String(q?.value ?? "").trim() === v)) return qrs;
  const insertAt = qrs.findIndex((q) => !isOfferPickQuickReply(q));
  const at = insertAt === -1 ? qrs.length : insertAt;
  const loadBtn = { label: "הצג עוד 5", value: v };
  return [...qrs.slice(0, at), loadBtn, ...qrs.slice(at)];
}
